import AboutVenue from './AboutVenue';
import Accommodations from './Accommodations';
import Awards from './our-awards/Awards';
import BannerWithSearchBar from './BannerWithSearchBar';
import BannerWithStats from './BannerWithStats';
import Benefits from './Benefits';
import BreadcrumbBackTo from './BreadcrumbBackTo';
import CalloutMessage from './CalloutMessage';
import CampusList from './CampusList';
import CompanyTypes from './CompanyTypes';
import ContactDetailsList from './ContactDetailsList';
import ContactUsForm from './ContactUsForm';
import ContentBlock from './ContentBlock';
import ContentBlockWithBullets from './ContentBlockWithBullets';
import DWTCVirtualAssetsApplications from './virtual-assets-applications/DWTCVirtualAssetsApplications';
import Downloadables from './Downloadables';
import DwtcVAApplicationProcess from './dwtc-va-application-process/DwtcVAApplicationProcess';
import DwtcVirtualAssetsIntro from './virtual-assets-intro/DwtcVirtualAssetsIntro';
import DwtcVirtualAssetsLicensedActivities from './virtual-assets-licensed-activities/DwtcVirtualAssetsLicensedActivities';
import DwtcVirtualIndustryGlobalIndustry from './virtual-global-industry/DwtcVirtualIndustryGlobalIndustry';
import EventsPaginated from './EventsPaginated';
import EventsSlider from './EventsSlider';
import Experiences from './Experiences';
import Facilities from './Facilities';
import FacilitiesAndServices from './FacilitiesAndServices';
import Faqs from './Faqs';
import FreezoneServices from './FreezoneServices';
import GoogleMapBlock from './GoogleMap';
import HomeBanner from './HomeBanner';
import HtmlContent from './HtmlContent';
import IFrame from './IFrame';
import ImageBanner from './ImageBanner';
import ImageCardsCarousel from './ImageCardsCarousel';
import ImageCarousel from './ImageCarousel';
import InsightsPaginated from './InsightsPaginated';
import InsightsSlider from './InsightsSlider';
import IntroWithStats from './IntroWithStats';
import Itineraries from './Itineraries';
import LatestNews from './LatestNews';
import LatestNewsPaginated from './LatestNewsPaginated';
import LeasePropertyForm from './LeasePropertyForm';
import MobileInnerNavbar from './MobileInnerNavbar';
import NewDevelopment from './NewDevelopment';
import OneColumnCTA from './OneColumnCTA';
import OurCampusCarousel from './OurCampusCarousel';
import OurStory from './OurStory';
import OurVisionMission from './our-vision-misson/OurVisionMission';
import PlanEventSliderBlock from './PlanEventSliderBlock';
import PortfolioTabs from './PortfolioTabs';
import ProjectList from './ProjectList';
import SearchResults from './SearchResults';
import Services from './Services';
import SocialMediaFloatingButtons from './SocialMediaFloatingButtons';
import Statistics from './Statistics';
import Testimonial from './Testimonial';
import TextCardsList from './TextCardsList';
import ThreeColumnsIntro from './ThreeColumnsIntro';
import TransportList from './TransportList';
import TripPlanner from './TripPlanner';
import TextAndVideo from './TextAndVideo';
import TwoColumnCTA from './TwoColumnCTA';
import TwoColumnTextWithIconBullets from './TwoColumnTextWithIconBullets';
import TwoColumnsText from './TwoColumnsText';
import TwoColumnsTextImage from './TwoColumnsTextImage';
import TwoColumnsImageTextCTA from './TwoColumnsImageTextCTA';
import TwoColumnsTextWithBullets from './TwoColumnsTextWithBullets';
import VenueExplorer from './VenueExplorer';
import InteractiveVenueExplorer from './InteractiveVenueExplorer';
import VenuesFilter from './VenuesFilter';
import VideoBanner from './VideoBanner';
import WhatWeDoTabs from './WhatWeDoTabs';
import HomeVideoBannerSlider from '../components-new/HomeVideoBannerSlider';
import FreeZoneInnerPageBanner from '../components-new/FreeZoneInnerPageBanner';
import FreeZoneTwoColumnsTextContentWithVideo from '../components-new/FreeZoneTwoColumnsTextContentWithVideo';
import FreeZoneTitleTwoColumnsTextWithVideo from '../components-new/FreeZoneTitleTwoColumnsTextWithVideo';
import FreeZoneTitleImageTextWithListIcons from '../components-new/FreeZoneTitleImageTextWithListIcons';
import FreeZoneTwoColTitleText from '../components-new/FreeZoneTwoColTitleText';
import FreeZoneTwoColumnsTextContentWithImage from '../components-new/FreeZoneTwoColumnsTextContentWithImage';
import FreeZonePrePostApplicationProcess from '../components-new/FreeZonePrePostApplicationProcess';
import FreeZoneOneColumnCTA from '../components-new/FreeZoneOneColumnCTA';
import FreeZoneStats from '../components-new/FreeZoneStats';
import FreeZoneStrategicLocation from '../components-new/FreeZoneStrategicLocation';
import FreeZoneTwoColTextVideoOffset from '../components-new/FreeZoneTwoColTextVideoOffset';
import FreeZoneDWTCAuthority from '../components-new/FreeZoneDWTCAuthority';
import FreeZoneTextContentWithThreeColumnCard from '../components-new/FreeZoneTextContentWithThreeColumnCard';
import FreeZoneKeyBenefitsListSlider from '../components-new/FreeZoneKeyBenefitsListSlider';
import FreeZoneTitleTextWithTwoCards from '../components-new/FreeZoneTitleTextWithTwoCards';
import FreeZoneTextWithImageCompose from '../components-new/FreeZoneTextWithImageCompose';
import FreeZoneFamilyOfficeBenefits from '../components-new/FreeZoneFamilyOfficeBenefits';
import FreeZoneServices from '../components-new/FreeZoneServices';
import FreeZoneTwoColTextContentWithTwoCards from '../components-new/FreeZoneTwoColTextContentWithTwoCards';
import FreeZoneVideoSlider from '../components-new/FreeZoneVideoSlider';
import FreeZoneOurClients from '../components-new/FreeZoneOurClients';
import FreeZoneVirtualAssetsPackages from '../components-new/FreeZoneVirtualAssetsPackages';
import FreeZoneGuideDownloads from '../components-new/FreeZoneGuideDownloads';
import FreeZoneFaq from '../components-new/FreeZoneFaq';
import FreeZoneRegulationsTwoCards from '../components-new/FreeZoneRegulationsTwoCards';
import FreeZoneApplicationProcess from '../components-new/FreeZoneApplicationProcess';
import FreeZoneRegulationsPaginated from '../components-new/FreeZoneRegulationsPaginated';
import FreeZoneLicenseActivities from '../components-new/FreeZoneLicenseActivities';
import FreeZoneSingleAccordion from '../components-new/FreeZoneSingleAccordion';
import FreeZoneTextContentCTAWithBgImage from '../components-new/FreeZoneTextContentCTAWithBgImage';
import FreeZoneTextContentWithOneColumnLists from '../components-new/FreeZoneTextContentWithOneColumnLists';
import FreeZoneOurOfficeSolution from '../components-new/FreeZoneOurOfficeSolution';
import FreeZoneFourCardsWithList from '../components-new/FreeZoneFourCardsWithList';
import FreeZoneBusinessCentreItems from '../components-new/FreeZoneBusinessCentreItems';
import FreeZoneThreeColCards from '../components-new/FreeZoneThreeColCards';
import FreeZoneActivityTable from '../components-new/FreeZoneActivityTable';
import FreeZoneGetInTouchTwoCol from '../components-new/FreeZoneGetInTouchTwoCol';
import FreeZoneTwoColImageCompose from '../components-new/FreeZoneTwoColImageCompose';
import FreeZoneHubServices from '../components-new/FreeZoneHubServices';
import FreeZoneAuthorityCoreServices from '../components-new/FreeZoneAuthorityCoreServices';
import FreeZoneStandardOffices from '../components-new/FreeZoneStandardOffices';
import FreeZoneConventionTower from '../components-new/FreeZoneConventionTower';
import FreeZoneTextContentWithTwoOverlapImage from '../components-new/FreeZoneTextContentWithTwoOverlapImage';
import FreeZoneInnerPageProcessMethod from '../components-new/FreeZoneInnerPageProcessMethod';
import FreeZoneHomeBusinessSteps from '../components-new/FreeZoneHomeBusinessSteps';
import FreeZoneForm from '../components-new/FreeZoneForm';
import FreeZoneVideoBlock from '../components-new/FreeZoneVideoBlock';
import FreeZoneStandardOfficesBenefits from '../components-new/FreeZoneStandardOfficesBenefits';
import FreeZoneFooterOneColumnCTA from '../components-new/FreeZoneFooterOneColumnCTA';
import FreeZoneBrowseLicenseType from '../components-new/FreeZoneBrowseLicenseType';
import FreeZoneApplicationTemplates from '../components-new/FreeZoneApplicationTemplates';
import IntroWithThreeColumnsIcons from './IntroWithThreeColumnsIcons';
import TwoColumnsCards from './TwoColumnsCards';
import OurCommitments from './OurCommitments';
import OurCertifications from './OurCertifications';
import DownloadSustainabilityReport from './DownloadSustainabilityReport';
import FreeZoneDownloadActivitiesList from '../components-new/FreeZoneDownloadActivitiesList';
import FreeZonePartnershipBenefits from '../components-new/FreeZonePartnershipBenefits';
import FreeZoneInstaFeed from '../components-new/FreeZoneInstaFeed';

export default {
  aboutVenue: AboutVenue,
  accommodations: Accommodations,
  awards: Awards,
  bannerWithSearchBar: BannerWithSearchBar,
  bannerWithStats: BannerWithStats,
  benefits: Benefits,
  breadcrumbBackTo: BreadcrumbBackTo,
  calloutMessage: CalloutMessage,
  campusList: CampusList,
  companyTypes: CompanyTypes,
  contactDetailsList: ContactDetailsList,
  contactUsForm: ContactUsForm,
  contentBlock: ContentBlock,
  contentBlockWithBullets: ContentBlockWithBullets,
  downloadables: Downloadables,
  dwtcVAApplicationProcess: DwtcVAApplicationProcess,
  dwtcVirtualAssetsApplications: DWTCVirtualAssetsApplications,
  dwtcVirtualAssetsIntro: DwtcVirtualAssetsIntro,
  dwtcVirtualAssetsLicensedActivities: DwtcVirtualAssetsLicensedActivities,
  dwtcVirtualIndustryGlobalIndustry: DwtcVirtualIndustryGlobalIndustry,
  eventsPaginated: EventsPaginated,
  eventsSlider: EventsSlider,
  experiences: Experiences,
  facilities: Facilities,
  facilitiesAndServices: FacilitiesAndServices,
  faqs: Faqs,
  freezoneServices: FreezoneServices,
  gettingHereNavbar: MobileInnerNavbar,
  googleMapBlock: GoogleMapBlock,
  htmlContent: HtmlContent,
  iframe: IFrame,
  imageBanner: ImageBanner,
  imageCardsCarousel: ImageCardsCarousel,
  imageCarousel: ImageCarousel,
  insightsPaginated: InsightsPaginated,
  insightsSlider: InsightsSlider,
  introWithStats: IntroWithStats,
  itineraries: Itineraries,
  introWithThreeColumnsIcons: IntroWithThreeColumnsIcons,
  latestNews: LatestNews,
  latestNewsPaginated: LatestNewsPaginated,
  leasePropertyForm: LeasePropertyForm,
  newDevelopment: NewDevelopment,
  oneColumnCTA: OneColumnCTA,
  ourCampusCarousel: OurCampusCarousel,
  ourStory: OurStory,
  ourVisionMission: OurVisionMission,
  portfolioTabs: PortfolioTabs,
  projectList: ProjectList,
  registerYourInterestForm: PlanEventSliderBlock,
  searchResults: SearchResults,
  services: Services,
  socialMediaFloatingButtons: SocialMediaFloatingButtons,
  statistics: Statistics,
  testimonial: Testimonial,
  textCardsList: TextCardsList,
  threeColumnsIntro: ThreeColumnsIntro,
  transportList: TransportList,
  tripPlanner: TripPlanner,
  textAndVideo: TextAndVideo,
  twoColumnTextWithIconBullets: TwoColumnTextWithIconBullets,
  twoColumnsCTA: TwoColumnCTA,
  twoColumnsText: TwoColumnsText,
  twoColumnsTextImage: TwoColumnsTextImage,
  twoColumnsImageTextCTA: TwoColumnsImageTextCTA,
  twoColumnsTextWithBullets: TwoColumnsTextWithBullets,
  venueExplorer: VenueExplorer,
  interactiveVenueExplorer: InteractiveVenueExplorer,
  venuesFilter: VenuesFilter,
  videoBanner: VideoBanner,
  videoSlider: HomeBanner,
  whatWeDoTabs: WhatWeDoTabs,
  dwtcHomeVideoBannerSlider: HomeVideoBannerSlider,
  dwtcFreeZoneInnerPageBanner: FreeZoneInnerPageBanner,
  dwtcFreeZoneTwoColumnsTextContentWithVideo: FreeZoneTwoColumnsTextContentWithVideo,
  dwtcFreeZoneTitleTwoColumnsTextWithVideo: FreeZoneTitleTwoColumnsTextWithVideo,
  dwtcFreeZoneTitleImageTextWithListIcons: FreeZoneTitleImageTextWithListIcons,
  dwtcFreeZoneTwoColTitleText: FreeZoneTwoColTitleText,
  dwtcFreeZoneTwoColumnsTextContentWithImage: FreeZoneTwoColumnsTextContentWithImage,
  dwtcFreeZonePrePostApplicationProcess: FreeZonePrePostApplicationProcess,
  dwtcFreeZoneOneColumnCTA: FreeZoneOneColumnCTA,
  dwtcFreeZoneStats: FreeZoneStats,
  dwtcFreeZoneStrategicLocation: FreeZoneStrategicLocation,
  dwtcFreeZoneTwoColTextVideoOffset: FreeZoneTwoColTextVideoOffset,
  dwtcFreeZoneDWTCAuthority: FreeZoneDWTCAuthority,
  dwtcFreeZoneTextContentWithThreeColumnCard: FreeZoneTextContentWithThreeColumnCard,
  dwtcFreeZoneKeyBenefitsListSlider: FreeZoneKeyBenefitsListSlider,
  dwtcFreeZoneTitleTextWithTwoCards: FreeZoneTitleTextWithTwoCards,
  dwtcFreeZoneTextWithImageCompose: FreeZoneTextWithImageCompose,
  dwtcFreeZoneFamilyOfficeBenefits: FreeZoneFamilyOfficeBenefits,
  dwtcFreeZoneServices: FreeZoneServices,
  dwtcFreeZoneTwoColTextContentWithTwoCards: FreeZoneTwoColTextContentWithTwoCards,
  dwtcFreeZoneVideoSlider: FreeZoneVideoSlider,
  dwtcFreeZoneOurClients: FreeZoneOurClients,
  dwtcFreeZoneVirtualAssetsPackages: FreeZoneVirtualAssetsPackages,
  dwtcFreeZoneGuideDownloads: FreeZoneGuideDownloads,
  dwtcFreeZoneFaq: FreeZoneFaq,
  dwtcFreeZoneRegulationsTwoCards: FreeZoneRegulationsTwoCards,
  dwtcFreeZoneApplicationProcess: FreeZoneApplicationProcess,
  dwtcFreeZoneRegulationsPaginated: FreeZoneRegulationsPaginated,
  dwtcFreeZoneLicenseActivities: FreeZoneLicenseActivities,
  dwtcFreeZoneSingleAccordion: FreeZoneSingleAccordion,
  dwtcFreeZoneTextContentCTAWithBgImage: FreeZoneTextContentCTAWithBgImage,
  dwtcFreeZoneTextContentWithOneColumnLists: FreeZoneTextContentWithOneColumnLists,
  dwtcFreeZoneOurOfficeSolution: FreeZoneOurOfficeSolution,
  dwtcFreeZoneFourCardsWithList: FreeZoneFourCardsWithList,
  dwtcFreeZoneBusinessCentreItems: FreeZoneBusinessCentreItems,
  dwtcFreeZoneThreeColCards: FreeZoneThreeColCards,
  dwtcFreeZoneActivityTable: FreeZoneActivityTable,
  dwtcFreeZoneGetInTouchTwoCol: FreeZoneGetInTouchTwoCol,
  dwtcFreeZoneTwoColImageCompose: FreeZoneTwoColImageCompose,
  dwtcFreeZoneHubServices: FreeZoneHubServices,
  dwtcFreeZoneAuthorityCoreServices: FreeZoneAuthorityCoreServices,
  dwtcFreeZoneStandardOffices: FreeZoneStandardOffices,
  dwtcFreeZoneConventionTower: FreeZoneConventionTower,
  dwtcFreeZoneTextContentWithTwoOverlapImage: FreeZoneTextContentWithTwoOverlapImage,
  dwtcFreeZoneInnerPageProcessMethod: FreeZoneInnerPageProcessMethod,
  dwtcFreeZoneHomeBusinessSteps: FreeZoneHomeBusinessSteps,
  dwtcFreeZoneForm: FreeZoneForm,
  dwtcFreeZoneVideoBlock: FreeZoneVideoBlock,
  dwtcFreeZoneStandardOfficesBenefits: FreeZoneStandardOfficesBenefits,
  dwtcFreeZoneFooterOneColumnCTA: FreeZoneFooterOneColumnCTA,
  dwtcFreeZoneBrowseLicenseType: FreeZoneBrowseLicenseType,
  dwtcFreeZoneApplicationTemplates: FreeZoneApplicationTemplates,
  twoColumnsCards: TwoColumnsCards,
  ourCommitments: OurCommitments,
  ourCertifications: OurCertifications,
  downloadSustainabilityReport: DownloadSustainabilityReport,
  dwtcFreeZoneDownloadActivitiesList: FreeZoneDownloadActivitiesList,
  dwtcFreeZonePartnershipBenefits: FreeZonePartnershipBenefits,
  dwtcFreeZoneInstaFeed: FreeZoneInstaFeed,
};
